<template>
  <div class="cl-sidebar" >
    <div class="cl-navblock">
      <div class="menu-space">
        <div class="content">
          <div class="sidebar-header">
            <strong class="sidebar-header__text" v-html="title"></strong>
            <p class="sidebar-header__date" v-html="description"></p>

            <c-button-link
                v-if="hasEditListener"
                size="sm"
                icon="fa-edit"
                @click="$emit('edit')"
            >{{ editLabel }}
            </c-button-link>

            <c-button-link
                theme="success"
                size="sm"
                icon="fa-arrow-up-right-from-square"
                @click="$emit('open')"
                v-if="showView">View
            </c-button-link>
          </div>
          <ul class="cl-vnavigation">
            <li v-if="!item.hidden || false" :class="`nav-checkin ${isActive(item) && 'active'}`" v-for="item in navigations">
              <a :href="item.url" v-if="!item.isExternal" :class="{'has-submenu': item?.submenu?.length} ">
                <i :class="item.icon"></i>
                <span>{{ item.label }}</span>
                <span class="badge" v-if="item.count">{{ item.count }}</span>
                <span v-if="item.agendaCount">+
                  <span class="badge badge-warning ml-0" data-toggle="tooltip" title="Agenda Sessions">
                    {{ item.agendaCount }}
                  </span>
                </span>
              </a>
              <router-link :to="item.url" v-if="item.isExternal">
                <i :class="item.icon"></i>
                <span>{{ item.label }}</span>
                <span class="badge" v-if="item.count">{{ item.count }}</span>
                <span v-if="item.agendaCount">+
                  <span class="badge badge-warning ml-0" data-toggle="tooltip" title="Agenda Sessions">
                    {{ item.agendaCount }}
                  </span>
                </span>
              </router-link>


              <ul class="sub-menu nav-days-list" v-if="item?.submenu?.length">
                <li v-for="submenu in item.submenu" :class="isActiveSubMenu(submenu) && 'active'">
                  <router-link :to="submenu.url">
                    {{ submenu.label }}
                  </router-link>
                </li>
              </ul>

              <ul class="sub-menu nav-days-list" v-if="item?.allowAddMore">
                <li>
                  <a

                      href="javascript:void(0);"
                      @click="$emit('add')"
                      class="color-success add-day"
                  >
                    <i class="fa-regular fa-plus"></i>
                    Add New Day
                  </a>
                </li>
              </ul>
            </li>
          </ul>

          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigations: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: 'Course'
    },
    showView: {
      type: Boolean,
      default: false
    },
    editLabel: {
      type: String,
      default: 'Edit',
    }
  },
  data() {
    return {
      pathName: window.location.pathname,
    }
  },
  computed:{
    hasEditListener(){
      return this.$listeners && this.$listeners.edit
    }
  },
  mounted() {
    $('.has-submenu').on('click', function(e) {
      const ul = $(this).parent().find('ul.nav-days-list');
      ul.slideToggle(300);

      e.preventDefault();
    });
  },
  methods: {
    isActiveSubMenu(item) {
      const existInList = item.session_ids.length ? item.session_ids.some(id => id == this.$route.params.sessionId) : false;

      return this.$route.path.includes(item.url) || existInList
    },
    isActive(item) {
      if (item.isExternal) {
        return this.$route.path.includes(item.url)
      } else {
        return window.location.pathname === item.url
      }
    }
  }
}
</script>

<style scoped lang="scss">

.cl-sidebar {
  background: white !important;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
}

.nav-days-list {


  &.nav-days-list--open {

  }

  li {
    &.active {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

}

.sidebar-header {
  padding: 0.5em;
  text-align: center;
}

.sidebar-header__text {
  font-weight: 400;
  font-size: 100%;
}

.sidebar-header__date {
}
</style>
